import React from 'react';
import {AssetGroup, PaginationSettings} from '@deviceinsight/ng-ui-api-client';

import {ContentHeader, ReactableWithClientSidePagination} from '@deviceinsight/ng-ui-components';

import {getStaticColumnDefs} from './columnDefinitions';
import {sort} from './utils';
import {
	DataProcessingDefinition,
	fetchDataProcessingDefinitionsAssignedToAssetGroup
} from '../../api/dataProcessingDefinitionApi';

const INITITAL_PAGINATION_SETTINGS: PaginationSettings = {
	page: 0,
	size: 10,
	sort: {
		property: 'kpiName',
		direction: 'ASC'
	}
};

const HEADER_TITLE = {
	id: 'assetgroups.detail.dataProcessingDefinition.list.title',
	defaultValue: 'Data Processing Definitions'
};

type Props = {
	assetGroup: AssetGroup;
	ancestorAssetGroups: Array<AssetGroup>;
};

type State = {
	dataProcessingDefinitions: Array<DataProcessingDefinition>;
	loading: boolean;
};

class AssetGroupDataProcessingDefinitionList extends React.Component<Props, State> {
	columnDefs: any = getStaticColumnDefs();
	state: State = {
		dataProcessingDefinitions: [],
		loading: true
	};

	componentDidMount() {
		const {
			assetGroup: {id}
		} = this.props;
		fetchDataProcessingDefinitionsAssignedToAssetGroup(id).then((dataProcessingDefinitions) =>
			this.setState({
				dataProcessingDefinitions,
				loading: false
			})
		);
	}

	render() {
		const {dataProcessingDefinitions, loading} = this.state;
		return (
			<div>
				<ContentHeader title={HEADER_TITLE} />
				<ReactableWithClientSidePagination
					columnDefs={this.columnDefs}
					uniqueItemKey={(item) => item.id}
					paginationSettings={INITITAL_PAGINATION_SETTINGS}
					items={dataProcessingDefinitions}
					isLoading={loading}
					customSortFunction={sort}
				/>
			</div>
		);
	}
}

export default AssetGroupDataProcessingDefinitionList;
